module.exports = __webpack_public_path__ + "6f72e32e6987922c022e141241a64175.png";